/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Params } from '@angular/router';

export interface StepsConfigModel {
  [stepCode: string]: StepConfigModel;
}

export interface StepConfigModel {
  path: string;
  absolutePath?: boolean;
  params?: Params;
}
